import React, { useCallback, useState } from "react";
import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";
import { clearAdminAuthStorage, getOrCreateAdminDeviceId, logoutAction } from "../../ustils/actioncreator";
import AdminNotificationMenu from "./AdminNotificationMenu";
function avatarLetterFromStorage() {
  try {
    const raw = localStorage.getItem("authUser");
    if (!raw) return "A";
    const u = JSON.parse(raw);
    const n = u?.name || u?.email || u?.full_name || "A";
    return String(n).trim()[0]?.toUpperCase() || "A";
  } catch {
    return "A";
  }
}

export default function AdminTopbar({ onToggleSidebar, leftOffset = 206 }) {
  const theme = useTheme();
  const topbar = theme.admin?.topbar || {};
  const navigate = useNavigate();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const avatarLetter = avatarLetterFromStorage();

  const handleLogout = useCallback(async () => {
    setMenuAnchor(null);
    setLogoutLoading(true);
    const deviceId = getOrCreateAdminDeviceId();
    try {
      await logoutAction(deviceId);
    } catch {
    } finally {
      clearAdminAuthStorage();
      setLogoutLoading(false);
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return (
    <Paper
      elevation={0}
      square
      sx={{
        position: "fixed",
        top: 0,
        left: { xs: 0, md: `${leftOffset}px` },
        right: 0,
        zIndex: 1200,
        height: 68,
        borderBottom: `1px solid ${topbar.border || theme.palette.divider}`,
        backdropFilter: "blur(12px)",
        bgcolor: topbar.bgcolor || theme.palette.background.paper,
        boxShadow: topbar.shadow || theme.shadows?.[1],
      }}
    >
      <Toolbar sx={{ minHeight: "68px !important", px: { xs: 1, sm: 1.5 } }}>
        <IconButton
          onClick={onToggleSidebar}
          size="small"
          sx={{
            color: topbar.menuBtn?.color || theme.palette.secondary.dark,
            bgcolor: topbar.menuBtn?.bgcolor || "rgba(212, 168, 74, 0.1)",
            border: topbar.menuBtn?.border || "1px solid rgba(212, 168, 74, 0.22)",
            "&:hover": {
              bgcolor: topbar.menuBtn?.hoverBg || "rgba(212, 168, 74, 0.18)",
              color: theme.palette.secondary.dark,
            },
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1.5 }}>
          <AdminNotificationMenu />
          <IconButton
            onClick={(e) => setMenuAnchor(e.currentTarget)}
            size="small"
            sx={{ p: 0 }}
            disabled={logoutLoading}
          >
            {logoutLoading ? (
              <CircularProgress size={22} />
            ) : (
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  fontSize: 13,
                  fontWeight: 600,
                  bgcolor: "#57bf78",
                  border: "2px solid rgba(255,255,255,0.9)",
                  boxShadow: "0 2px 8px rgba(87, 191, 120, 0.35)",
                }}
              >
                {avatarLetter}
              </Avatar>
            )}
          </IconButton>
          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
            <MenuItem onClick={handleLogout} disabled={logoutLoading}>
              <ListItemIcon>
                <LogoutOutlinedIcon fontSize="small" />
              </ListItemIcon>
              Log out
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </Paper>
  );
}
